import { COLORS } from '../../config/designSystem/Colors';
import { EvolunoCheck } from '../../assets/images/Icons/Check/EvolunoCheck';
import { View } from 'react-native';

export const SIZE_GREEN_CIRCLE = 30;
export const SIZE_WHITE_CIRCLE = 60;

export const CheckIconPath = () => {


  return(<View style={{
    backgroundColor:COLORS.surface.primary,
    position: 'absolute',
    width:SIZE_WHITE_CIRCLE,
    height:SIZE_WHITE_CIRCLE,
    borderRadius:SIZE_WHITE_CIRCLE/2,
    justifyContent:'center',
    alignItems: 'center'
  }}>
    <View
      style={{
        backgroundColor:COLORS.state.success.primary,
        width:SIZE_GREEN_CIRCLE,
        height:SIZE_GREEN_CIRCLE,
        borderRadius:SIZE_GREEN_CIRCLE/2,
        justifyContent:'center',
        alignItems: 'center'
      }}>
      <EvolunoCheck size={SIZE_GREEN_CIRCLE/2} color={'white'} />
    </View>
  </View>);
};